export default "__VITE_ASSET__CbDrKW21__"